import SgeDashboardAppService from '../../../../application/platform/sge/dashboard/sge-dashboard-app-service';
import { ACTION_TYPES, useDashboardDispatch } from './dashboard-context';
import { useFeedback } from '../../../../hooks/use-feedback';

export const useDashboardController = () => {
    const { showError, withLoading } = useFeedback();
    const dispatch = useDashboardDispatch();

    async function loadData() {
        dispatch({ type: ACTION_TYPES.setLoading, payload: true });
        dispatch({ type: ACTION_TYPES.setError, payload: null });
        try {
            const data = await withLoading(() => SgeDashboardAppService.getOverview());
            dispatch({ type: ACTION_TYPES.setDashboardData, payload: data });
        } catch (error: any) {
            showError('Não foi possível carregar o painel de controle', error);
            dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar dados do dashboard' });
        } finally {
            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
        }
    }

    return { loadData };
};
